import { ReactElement } from "react";
import React from "react";

type A11yButtonProps = {
  onClick: () => void;
  children: React.ReactNode;
};

const A11yButton: React.FC<A11yButtonProps & Record<string, any>> = ({
  onClick,
  children,
  ...props
}): ReactElement => {
  const { style, ...otherProps } = props;

  return (
    <div
      onClick={onClick}
      onKeyDown={keyDownA11y(onClick)}
      role="button"
      tabIndex={0}
      style={{ cursor: "pointer", ...style }}
      {...otherProps}
    >
      {children}
    </div>
  );
};

function keyDownA11y(handler: () => void) {
  return function onKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (
      ["keydown", "keypress"].includes(e.type) &&
      ["Enter", " "].includes(e.key)
    ) {
      handler();
    }
  };
}

export default A11yButton;
